// btw-front/src/api/partnerPerformance.js
import { api } from "./client";

export async function get() {
  // 응답: { kpi, byQuarter, topCustomers, recentActivity }
  return api.get("/partner/performance");
}
